/**
 * 複数のコンポーネントで共通して使用することが見込まれる関数を
 * 一か所で管理するためのJSファイル
 */

/**
 * Storeから取得してきたデータのうちKeysに含まれるものをsetterつきのcomputedデータとして扱えるよう変換する
 * @param {Array} keys
 */
export function mapComputedProperties(keys) {
    const map = []
    keys.forEach(key => {
        map[key] = {
            get(){
                return this.data[key]
            },
            set(newValue){
                this.update({
                    [key]:newValue
                })
            }
        }
    })
    return map
}